import { call, put, takeLatest, select } from "redux-saga/effects";
import { loadProfileDataFailed } from "./actions";
import { selectUserId } from "../../util/selectors";
import { initialize, startSubmit, stopSubmit } from "redux-form";
import UserApi from "../../api/UserApi";
import api from "../../api/api";
import { getProfilePictureUrl } from "../../util";
import { showAlert } from "../../actions";
import { push } from "redux-little-router";
import mixpanel from "../../services/mixpanel";

function* handleLoadProfileData() {
  const userId = yield select(selectUserId);
  const loadProfileDataRequest = UserApi.getLoadUserByIdUrl(userId);
  try {
    const { data: { name, email, country, speciality, uid, headline, shortBio } } = yield call(
      api.get,
      loadProfileDataRequest.url,
      loadProfileDataRequest.config
    );

    mixpanel.time_event("profile.edit");
    yield put(
      initialize("settingsForm", {
        name,
        email,
        country,
        speciality,
        headline,
        shortBio,
        picture: getProfilePictureUrl(uid, "m") + `?q=${Date.now()}`,
      })
    );
  } catch (error) {
    yield put(loadProfileDataFailed(error));
  }
}

function* handleUpdateProfileData({ profileData }) {
  const data = profileData.picture.includes("/temp") ? { ...profileData, isProfilePictureUpdated: true } : profileData;
  yield put(startSubmit("settingsForm"));
  const updateProfileDataRequest = UserApi.getUpdateUserUrl(data);

  try {
    yield call(api.put, updateProfileDataRequest.url, updateProfileDataRequest.config);
    const alertMessage = data.isProfilePictureUpdated
      ? "Your profile image will be updated within minutes."
      : "Your profile has been updated successfully!";
    yield put(showAlert(alertMessage));
    mixpanel.track("profile.edit", data);
    mixpanel.people.set({
      $email: data.email,
      $name: data.name,
      country: data.country,
      speciality: data.speciality,
    });
    const userId = yield select(selectUserId);
    yield put(push(`/profile/${userId}`));
  } catch (error) {
    const errorObject = error.response.data.error.includes("expected `email` to be unique")
      ? { email: "This email already exists." }
      : { _error: "Unexpected error occurred, please try again." };
    yield put(stopSubmit("settingsForm", errorObject));
  }
}

export function* watchProfileSettingsRequests(props) {
  yield takeLatest("LOAD_PROFILE_DATA_REQUEST", handleLoadProfileData);
  yield takeLatest("UPDATE_PROFILE_DATA_REQUEST", handleUpdateProfileData);
}



// WEBPACK FOOTER //
// ./src/scenes/EditProfilePage/sagas.js